import { render } from "./HGivePointPageIcon.vue?vue&type=template&id=32eaca0c&scoped=true&ts=true"
import script from "./HGivePointPageIcon.vue?vue&type=script&lang=ts"
export * from "./HGivePointPageIcon.vue?vue&type=script&lang=ts"

import "./HGivePointPageIcon.vue?vue&type=style&index=0&id=32eaca0c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32eaca0c"]])

export default __exports__